import { WaypointTypeEnum } from '../../../../enums/TmsEnum';

export enum DrawerMode {
    Create = 'create',
    Edit = 'edit',
    View = 'view',
}

export interface StationRow {
    key: string | number;
    type: WaypointTypeEnum;
    station: string;
    travelTime: number;
    dwellTime: number;
    distance: number;
    /** 扩展三方途经点ID（编辑时从后端带回） */
    extWaypointId?: number | null;
}

export interface WarehouseOption {
    id: string;
    sortingCode: string;
    parentSiteId: string;
    siteType: number;
    /** 仓库名称；用于将 Temu 配置 siteName 与仓库匹配 */
    name?: string;
    /** external_station 表主键 id，写入途经点 ext_waypoint_id */
    externalStationId?: number | null;
    /** 是否测试站点；测试仓只能选测试站点，正式仓只能选正式站点 */
    isTest: boolean;
}

export interface RouteFormFilters {
    routeType: number | undefined;
    businessType: number | undefined;
    carrierId: string | undefined;
    status: number | undefined;
}
